import {Component} from 'react';
import {inject, observer} from 'mobx-react';

@inject('store')
@observer
class RestoredScroll extends Component {
  async componentDidMount() {
    const {ui} = this.props.store;

    if (await ui.shouldScrollBeRestored) {
      ui.restoreScroll(this.props.fallback);
    }
  }

  render() {
    return this.props.children || null;
  }
}

export default RestoredScroll;
